import { useEffect, useState } from "react"

import { Button, Table, Popover, PopoverBody } from "reactstrap"

import { useScenario } from "../contexts/ScenarioContext"

import { MDB_TYPES as TYPES } from "@meddbriefer/scenario-data/constants.js"

const CATEGORY = "intervention-status"




const InterventionsGroup = ({intvs}) => {
    const { logPatientStatusRequest } = useScenario()
    const [popoverOpen, setPopoverOpen] = useState(false); 

    const hideOverlay = () => {
        setTimeout(function(){setPopoverOpen(false)}, 500)
    } 

    const clickHandler = (intv) => {
        // const intervention = checkListItems.find(rec => rec.id === intvID)
        setPopoverOpen(true)
        logPatientStatusRequest(CATEGORY, intv.interventionID, intv.patientStatus)
        hideOverlay()
} 

    let numToDisplay = 2
    let intvsToDisplay = []
    if (intvs.length >= numToDisplay) {
        for (let index = 1; index <= numToDisplay; index++) {
            intvsToDisplay.push(intvs[(intvs.length)-index])    
        }
        intvsToDisplay = intvsToDisplay.reverse()
    }
    else {intvsToDisplay = intvs}


    return (
        <tbody>
        {intvsToDisplay.map((intv, index) => (
            
            <tr key={`intv-performed-${intv.interventionID}-${index}`}>
                <td>{intv.label}</td>
                <td>{intv.patientStatus}</td>
                <td>
                    <div>
                    <Button
                        id = 'intvBtn'
                        color="success"
                        size="sm"
                        className="request-btn"
                        onClick={() => clickHandler(intv)}
                    >
                        Requested
                    </Button>
                    <Popover
                        size="sm"
                        placement="left-end" 
                        isOpen={popoverOpen}
                        target='intvBtn'
                        trigger="focus"
                        >
                        <PopoverBody>Recorded</PopoverBody>
                    </Popover>
                    </div>
                </td>
            </tr>
        ))}
        </tbody>
    )
}

const IntvTable = ({intvs}) => {
    return (
        <Table size="sm" striped={true} bordered={false}>
            <thead>
                <tr>
                    <th>Intervention</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            {intvs.length > 0 &&
                <InterventionsGroup
                    intvs={intvs}
                />
            }
        </Table>
    )
}

const InterventionStatus = ()  => {
        const { intvHistory } = useScenario()
        const [intvsPerformed, setIntvsPerformed] = useState([])
    
        const getSystemIntvsPerformed = () => {
            const recs = Object.values(intvHistory)
                .filter(val => !!val)
                .filter(rec => rec.type === TYPES.INTERV)
                .filter(rec => !!rec.patientStatus)
                //.filter(rec => !!rec.system)  
            recs.sort((a, b) => a.timestamp - b.timestamp)
            return recs
        }
 
        
        
        useEffect(
            () => {
                const intvs = getSystemIntvsPerformed()
                if (intvs !== intvsPerformed) {
                    setIntvsPerformed(intvs)
                }
            }, [intvHistory]
        )
    
        return (
                <IntvTable
                    intvs={intvsPerformed}
            />
        )
    }
    


export default InterventionStatus